import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'
import { type EarnPointsCalculationOptions, mapRequestToPayload, mapResponseToCalculation } from 'api/mappers/loyalty/mapLoyaltyEarnPointsCalculation'

type Payload = paths['/api/lux-loyalty/points/calculate-earn']['post']['requestBody']['content']['application/json']
type Response = paths['/api/lux-loyalty/points/calculate-earn']['post']['responses']['200']['content']['application/json']
type PostPurchasePayload = paths['/api/lux-loyalty/points/calculate-earn/post-purchase']['post']['requestBody']['content']['application/json']

export type { EarnPointsCalculationOptions as Options }
export { mapRequestToPayload, mapResponseToCalculation }

export async function requestLoyaltyEarnPointsCalculation(request: App.LoyaltyPointsEarnCalculationRequest, options: EarnPointsCalculationOptions): Promise<App.LoyaltyPointsEarnCalculation> {
  const payload = mapRequestToPayload(request, options)

  const response = await requestUtils.post<Response, Payload>('/api/lux-loyalty/points/calculate-earn',
    payload,
    { credentials: 'include' },
  )

  return mapResponseToCalculation(request, response.result, options)
}

interface PostPurchaseOptions extends EarnPointsCalculationOptions {
  orderItemId?: string
  orderId?: string
}

/**
 * Calculate loyalty points for a post-purchase item update, with the original order's booking date
 * and region so the order keeps the earn rules it was booked under.
 */
export async function requestLoyaltyEarnPointsCalculationPostPurchase(
  request: App.LoyaltyPointsEarnCalculationRequest,
  options: PostPurchaseOptions,
): Promise<App.LoyaltyPointsEarnCalculation> {
  if (!options.orderItemId || !options.orderId) {
    throw new Error('orderItemId and orderId are required', { cause: { orderItemId: options.orderItemId, orderId: options.orderId } })
  }

  const payload: PostPurchasePayload = {
    ...mapRequestToPayload(request, options),
    itemId: options.orderItemId,
    orderId: options.orderId,
  }

  const response = await requestUtils.post<Response, PostPurchasePayload>('/api/lux-loyalty/points/calculate-earn/post-purchase',
    payload,
    { credentials: 'include' },
  )

  return mapResponseToCalculation(request, response.result, options)
}
